<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>项目</el-breadcrumb-item>
        <el-breadcrumb-item>分销推广</el-breadcrumb-item>
        <el-breadcrumb-item>推广人员</el-breadcrumb-item>
        <el-breadcrumb-item>邀请列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">邀请列表</h2>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">邀请列表</h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="uid"
            label="用户ID"
            width="80px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="inviter_name"
            label="状态"
            width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                v-if="scope.row.promoter_type==0"
                type="warning"
              >未提交</el-tag>
              <el-tag
                size="mini"
                v-if="scope.row.promoter_type==1"
              >自审核</el-tag>
              <el-tag
                size="mini"
                v-if="scope.row.promoter_type==2"
              >邀审核</el-tag>
              <el-tag
                size="mini"
                v-if="scope.row.promoter_type==3"
                type="success"
              >自通过</el-tag>
              <el-tag
                size="mini"
                v-if="scope.row.promoter_type==4"
                type="success"
              >邀通过</el-tag>
              <el-tag
                size="mini"
                type="danger"
                v-if="scope.row.promoter_type==5"
              >已拒绝</el-tag>
              <el-tag
                size="mini"
                type="danger"
                v-if="scope.row.promoter_type==6"
              >已清退</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="邀请日期"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm:ss")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="inviter_nickname"
            label="邀请已获奖励"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.inviter_total_amount}}元
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>

import { referrerInviterlist, memberpromoterEdit } from "@/api/distribution";
export default {
  components: {

  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      filter: {
        status: [
          { label: "已审核", value: "" },
          { label: "未审核", value: "1" },
          { label: "未提交", value: "0" },
        ],
        promoter_types: [
          { label: "未提交", value: "0" },
          { label: "自审核", value: "1" },
          { label: "邀审核", value: "2" },
          { label: "自通过", value: "3" },
          { label: "邀通过", value: "4" },
          { label: "已拒绝", value: "5" },
          { label: "已清退", value: "6" },
        ]
      },
    };
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      const params = Object.assign({}, this.query);
      params.uid = this.$route.query.id

      referrerInviterlist(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query);
      if (params.promoter_type) {
        params.promoter_type = params.promoter_type.filter((v) => v).join(",");
      }
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
</style>
